import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(["o-ico", $props.class]),
    "aria-hidden": "true",
    role: "img"
  }, [
    _createElementVNode("use", {
      "xlink:href": this.$root.spriteURL+'#'+$props.icon
    }, null, 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}